import React, { useEffect, useState } from 'react'
import { Button, Modal, Pagination, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import * as TableUI from '../../../../components/Table/Table'
import i18next from 'i18next'
import { useRowTable } from 'src/hooks/useRowTable'
import { TextInputV2 } from 'src/components'

type Prop = {
    show: boolean,
    loading: boolean,
    reload: () => void,
    setShow: (p1: boolean) => void,
    datas: any[]
}

const ShowStock: React.FC<Prop> = ({
    show,
    loading,
    reload,
    setShow,
    datas
}) => {
    const {t} = useTranslation()

    const [filtered, setFiltered] = useState<any[]>([])
    const [paged, setPaged] = useState<any[]>([])

    const [currPage, setCurrPage] = useState(1)
    const [pages, setPages] = useState<any[]>([])
    const [totalPages, setTotalPages] = useState(1)

    const {RowLoader, RowEmptyData} = useRowTable({
        colSpan: 8,
        onReloadTable:() => reload()
    })

    const limit = 10

    useEffect(() => {
        setFiltered(datas)
    }, [datas])
    useEffect(() => {
        applyPagination()
    }, [filtered, currPage])

    const formatStock = (stock: number, ptype: string, _unit: string = '') => {
        let num = stock?.toLocaleString(i18next.language, {
          maximumFractionDigits: 4,
        })
        let unit = ptype == '8105' ? _unit : i18next.language == 'id' ? 'Ton' : 'MT'
    
        return num ? [num, unit].join(' ') : '-'
    }

    const isMatch = (data: any, fil: any) => {
        if(typeof data == 'number'){
            return (data.toString().toLowerCase()).includes(fil.toLowerCase())
        }else{
            return (data.toLowerCase()).includes(fil.toLowerCase())
        }
    }

    const applyFilter = (filter: Record<string, any>) => {
        setCurrPage(1)
        setPages([])
        setTotalPages(1)

        const filteredData = datas.filter((item: any) => {
            let match = true;

            if(filter.material && (
                !(isMatch(parseInt(item?.material_number), filter.material))
                && !(isMatch(item?.material_desc, filter.material))
            )) {
                match = false;
            }
            if(filter.plant && (
                !(isMatch(item?.plant, filter.plant))
                && !(isMatch(item?.plant_desc, filter.plant))
            )) {
                match = false;
            }
            if(filter.sloc && (
                !(isMatch(item?.sloc, filter.sloc))
                && !(isMatch(item?.sloc_desc, filter.sloc))
            )) {
                match = false;
            }
            
            if(filter.uu && item?.stock != filter.uu) {
                match = false;
            }

            if(filter.sap && item?.stock != filter.sap) {
                match = false;
            }

            if(filter.outstanding && item?.stock_used != filter.outstanding) {
                match = false;
            }
            if(filter.remaining && item?.stock_available != filter.remaining) {
                match = false;
            }

            return match
        })

        setFiltered(filteredData)
    }

    const applyPagination = () => {
        let count = filtered.length
        let _totalPages = (count != 0) ? Math.ceil(count / limit) : 1;

        setPaged([])

        var _pages = [];
        
        let startPage, endPage;
        const maxVisiblePages = 7;
        if (currPage <= Math.floor(maxVisiblePages / 2) + 1) {
            startPage = 1;
            endPage = maxVisiblePages;
        }
        else if (currPage + Math.floor(maxVisiblePages / 2) >= _totalPages) {
            startPage = _totalPages - maxVisiblePages + 1;
            endPage = _totalPages;
        }
        else {
            startPage = currPage - Math.floor(maxVisiblePages / 2);
            endPage = currPage + Math.floor(maxVisiblePages / 2);
        }

        if(_totalPages > 7){
            if(startPage > 1){
                _pages.push(0)
                _pages.push('-')
                _pages.push('...')
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            if(i > 0 && i <= _totalPages){
                _pages.push(i);
            }
        }

        if(_totalPages > 7){
            if(endPage < _totalPages-maxVisiblePages){
                _pages.push('...')
                _pages.push('+')
                _pages.push(-1)
            }
        }

        setPages(_pages)
        setTotalPages(_totalPages)

        const startIndex = (currPage - 1) * limit
        setPaged(filtered.slice(startIndex, startIndex + limit))
    }

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        size='xl'
        scrollable
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('order-cekStock')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='d-flex justify-content-end'>
                <Button disabled={loading} variant='primary' onClick={() => reload()}>
                    <i className={'fa fa-refresh ' + (loading ? 'fa-spin' : '')}></i>
                </Button>
            </div>

            <div className='table-responsive bdr my-4'>
                <TableUI.Table>
                <TableUI.THead>
                    <tr>
                    <th className='text-center'>{t('No')}</th>
                    <th className='text-center'>{t('sub-order-produk')}</th>
                    <th className='text-center'>{t('sub-order-gudang')}</th>
                    <th className='text-center'>{t('storage location')}</th>
                    <th className='text-center'>{t('uu-stock')}</th>
                    <th className='text-center'>{t('sap-stock')}</th>
                    <th className='text-center'>{t('outstanding-stock')}</th>
                    <th className='text-center'>{t('remaining-stock')}</th>
                    </tr>
                </TableUI.THead>
                <TableUI.TBody>
                    <RowFilter applyFilter={applyFilter}/>
                    {
                        loading ? <RowLoader/> : (
                            paged?.length == 0 ? <RowEmptyData/> :
                            paged?.map((item: any, _index: number) => (
                        <tr key={item?.code ?? _index}>
                            <td>{( (currPage - 1) * limit ) + _index + 1}</td>
                            <td>{[parseInt(item?.material_number), item?.material_desc].join(' - ')}</td>
                            <td>{[item?.plant, item?.plant_desc].join(' - ')}</td>
                            <td>{[item?.sloc, item?.sloc_desc].join(' - ')}</td>
                            <td>{formatStock(item.stock_uu, item?.product_type, item?.unit)}</td>
                            <td>{formatStock(item.stock, item?.product_type, item?.unit)}</td>
                            <td>
                            {item.stock_used ? formatStock(item.stock_used, item?.product_type, item?.unit) : '-'}
                            </td>
                            <td>{formatStock(item.stock_available, item?.product_type)}</td>
                        </tr>
                        )
                        )
                )}
                </TableUI.TBody>
                </TableUI.Table>
            </div>

            <Pagination>
                {
                    pages.map((page) => {
                        if(page == '-'){
                            return <Pagination.Prev onClick={() => setCurrPage(currPage-1)}/>
                        }
                        if(page == 0){
                            return <Pagination.First onClick={() => setCurrPage(1)}/>
                        }
                        if(page == '+'){
                            return <Pagination.Next onClick={() => setCurrPage(currPage+1)}/>
                        }
                        if(page == -1){
                            return <Pagination.Last onClick={() => setCurrPage(totalPages)}/>
                        }
                        if(page == '...'){
                            return  <Pagination.Ellipsis disabled/>
                        }
                        return <Pagination.Item onClick={() => setCurrPage(page)} active={page == currPage} key={'page-' + page}>{page}</Pagination.Item>
                    })
                }
            </Pagination>
        </Modal.Body>
      </Modal>
    </>
  )
}

type RowFilterProp = {
    applyFilter: (p1: Record<string, any>) => void,
}

const RowFilter: React.FC<RowFilterProp> = ({
    applyFilter
}) => {
    const {t} = useTranslation()

    const [filter, setFilter] = useState({
        material: null,
        plant: null,
        sloc: null,
        uu: null,
        sap: null,
        outstanding: null,
        remaining: null
    })

    const handleChange = (fil : Record<string, any>) => {
        const newFilter = {
            ...filter,
            ...fil
        }
        setFilter(newFilter)
        applyFilter(newFilter)
    }

    return (
        <>
        <TableUI.TRowFilter>
            <td>
                <div></div>
            </td>
            <td>
                <TextInputV2
                    type='text'
                    placeholder={t('sub-order-produk')}
                    onChange={(e: any) => handleChange({material: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='text'
                    placeholder={t('sub-order-gudang')}
                    onChange={(e: any) => handleChange({plant: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='text'
                    placeholder={t('storage location')}
                    onChange={(e: any) => handleChange({sloc: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('uu-stock')}
                    onChange={(e: any) => handleChange({uu: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('sap-stock')}
                    onChange={(e: any) => handleChange({sap: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('outstanding-stock')}
                    onChange={(e: any) => handleChange({outstanding: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('remaining-stock')}
                    onChange={(e: any) => handleChange({remaining: e.target.value})}
                    />
            </td>
      </TableUI.TRowFilter>
        </>
    )
}

export {ShowStock}
